import Xe, { useRef as ze, useState as C, useEffect as Se } from "react";
var Te = { exports: {} }, we = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ue;
function gr() {
  if (Ue) return we;
  Ue = 1;
  var y = Xe, M = Symbol.for("react.element"), F = Symbol.for("react.fragment"), D = Object.prototype.hasOwnProperty, z = y.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, U = { key: !0, ref: !0, __self: !0, __source: !0 };
  function A(k, d, _) {
    var b, x = {}, P = null, W = null;
    _ !== void 0 && (P = "" + _), d.key !== void 0 && (P = "" + d.key), d.ref !== void 0 && (W = d.ref);
    for (b in d) D.call(d, b) && !U.hasOwnProperty(b) && (x[b] = d[b]);
    if (k && k.defaultProps) for (b in d = k.defaultProps, d) x[b] === void 0 && (x[b] = d[b]);
    return { $$typeof: M, type: k, key: P, ref: W, props: x, _owner: z.current };
  }
  return we.Fragment = F, we.jsx = A, we.jsxs = A, we;
}
var je = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Be;
function mr() {
  return Be || (Be = 1, process.env.NODE_ENV !== "production" && function() {
    var y = Xe, M = Symbol.for("react.element"), F = Symbol.for("react.portal"), D = Symbol.for("react.fragment"), z = Symbol.for("react.strict_mode"), U = Symbol.for("react.profiler"), A = Symbol.for("react.provider"), k = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), _ = Symbol.for("react.suspense"), b = Symbol.for("react.suspense_list"), x = Symbol.for("react.memo"), P = Symbol.for("react.lazy"), W = Symbol.for("react.offscreen"), te = Symbol.iterator, h = "@@iterator";
    function se(e) {
      if (e === null || typeof e != "object")
        return null;
      var r = te && e[te] || e[h];
      return typeof r == "function" ? r : null;
    }
    var O = y.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(e) {
      {
        for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
          t[n - 1] = arguments[n];
        ae("error", e, t);
      }
    }
    function ae(e, r, t) {
      {
        var n = O.ReactDebugCurrentFrame, c = n.getStackAddendum();
        c !== "" && (r += "%s", t = t.concat([c]));
        var f = t.map(function(s) {
          return String(s);
        });
        f.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, f);
      }
    }
    var le = !1, J = !1, ce = !1, B = !1, ue = !1, Y;
    Y = Symbol.for("react.module.reference");
    function fe(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === D || e === U || ue || e === z || e === _ || e === b || B || e === W || le || J || ce || typeof e == "object" && e !== null && (e.$$typeof === P || e.$$typeof === x || e.$$typeof === A || e.$$typeof === k || e.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === Y || e.getModuleId !== void 0));
    }
    function V(e, r, t) {
      var n = e.displayName;
      if (n)
        return n;
      var c = r.displayName || r.name || "";
      return c !== "" ? t + "(" + c + ")" : t;
    }
    function H(e) {
      return e.displayName || "Context";
    }
    function w(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case D:
          return "Fragment";
        case F:
          return "Portal";
        case U:
          return "Profiler";
        case z:
          return "StrictMode";
        case _:
          return "Suspense";
        case b:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case k:
            var r = e;
            return H(r) + ".Consumer";
          case A:
            var t = e;
            return H(t._context) + ".Provider";
          case d:
            return V(e, e.render, "ForwardRef");
          case x:
            var n = e.displayName || null;
            return n !== null ? n : w(e.type) || "Memo";
          case P: {
            var c = e, f = c._payload, s = c._init;
            try {
              return w(s(f));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var R = Object.assign, S = 0, q, N, G, $, K, Z, Q;
    function de() {
    }
    de.__reactDisabledLog = !0;
    function be() {
      {
        if (S === 0) {
          q = console.log, N = console.info, G = console.warn, $ = console.error, K = console.group, Z = console.groupCollapsed, Q = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: de,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        S++;
      }
    }
    function he() {
      {
        if (S--, S === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: R({}, e, {
              value: q
            }),
            info: R({}, e, {
              value: N
            }),
            warn: R({}, e, {
              value: G
            }),
            error: R({}, e, {
              value: $
            }),
            group: R({}, e, {
              value: K
            }),
            groupCollapsed: R({}, e, {
              value: Z
            }),
            groupEnd: R({}, e, {
              value: Q
            })
          });
        }
        S < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var X = O.ReactCurrentDispatcher, ve;
    function ne(e, r, t) {
      {
        if (ve === void 0)
          try {
            throw Error();
          } catch (c) {
            var n = c.stack.trim().match(/\n( *(at )?)/);
            ve = n && n[1] || "";
          }
        return `
` + ve + e;
      }
    }
    var ge = !1, l;
    {
      var ee = typeof WeakMap == "function" ? WeakMap : Map;
      l = new ee();
    }
    function o(e, r) {
      if (!e || ge)
        return "";
      {
        var t = l.get(e);
        if (t !== void 0)
          return t;
      }
      var n;
      ge = !0;
      var c = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var f;
      f = X.current, X.current = null, be();
      try {
        if (r) {
          var s = function() {
            throw Error();
          };
          if (Object.defineProperty(s.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(s, []);
            } catch (E) {
              n = E;
            }
            Reflect.construct(e, [], s);
          } else {
            try {
              s.call();
            } catch (E) {
              n = E;
            }
            e.call(s.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (E) {
            n = E;
          }
          e();
        }
      } catch (E) {
        if (E && n && typeof E.stack == "string") {
          for (var i = E.stack.split(`
`), j = n.stack.split(`
`), m = i.length - 1, p = j.length - 1; m >= 1 && p >= 0 && i[m] !== j[p]; )
            p--;
          for (; m >= 1 && p >= 0; m--, p--)
            if (i[m] !== j[p]) {
              if (m !== 1 || p !== 1)
                do
                  if (m--, p--, p < 0 || i[m] !== j[p]) {
                    var I = `
` + i[m].replace(" at new ", " at ");
                    return e.displayName && I.includes("<anonymous>") && (I = I.replace("<anonymous>", e.displayName)), typeof e == "function" && l.set(e, I), I;
                  }
                while (m >= 1 && p >= 0);
              break;
            }
        }
      } finally {
        ge = !1, X.current = f, he(), Error.prepareStackTrace = c;
      }
      var ye = e ? e.displayName || e.name : "", ie = ye ? ne(ye) : "";
      return typeof e == "function" && l.set(e, ie), ie;
    }
    function u(e, r, t) {
      return o(e, !1);
    }
    function v(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function L(e, r, t) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return o(e, v(e));
      if (typeof e == "string")
        return ne(e);
      switch (e) {
        case _:
          return ne("Suspense");
        case b:
          return ne("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case d:
            return u(e.render);
          case x:
            return L(e.type, r, t);
          case P: {
            var n = e, c = n._payload, f = n._init;
            try {
              return L(f(c), r, t);
            } catch {
            }
          }
        }
      return "";
    }
    var T = Object.prototype.hasOwnProperty, re = {}, me = O.ReactDebugCurrentFrame;
    function oe(e) {
      if (e) {
        var r = e._owner, t = L(e.type, e._source, r ? r.type : null);
        me.setExtraStackFrame(t);
      } else
        me.setExtraStackFrame(null);
    }
    function Re(e, r, t, n, c) {
      {
        var f = Function.call.bind(T);
        for (var s in e)
          if (f(e, s)) {
            var i = void 0;
            try {
              if (typeof e[s] != "function") {
                var j = Error((n || "React class") + ": " + t + " type `" + s + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[s] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw j.name = "Invariant Violation", j;
              }
              i = e[s](r, s, n, t, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (m) {
              i = m;
            }
            i && !(i instanceof Error) && (oe(c), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", n || "React class", t, s, typeof i), oe(null)), i instanceof Error && !(i.message in re) && (re[i.message] = !0, oe(c), g("Failed %s type: %s", t, i.message), oe(null));
          }
      }
    }
    var Je = Array.isArray;
    function Ee(e) {
      return Je(e);
    }
    function qe(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, t = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return t;
      }
    }
    function Ge(e) {
      try {
        return Ie(e), !1;
      } catch {
        return !0;
      }
    }
    function Ie(e) {
      return "" + e;
    }
    function Fe(e) {
      if (Ge(e))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", qe(e)), Ie(e);
    }
    var xe = O.ReactCurrentOwner, Ke = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, De, Ne, ke;
    ke = {};
    function Ze(e) {
      if (T.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function Qe(e) {
      if (T.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function er(e, r) {
      if (typeof e.ref == "string" && xe.current && r && xe.current.stateNode !== r) {
        var t = w(xe.current.type);
        ke[t] || (g('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', w(xe.current.type), e.ref), ke[t] = !0);
      }
    }
    function rr(e, r) {
      {
        var t = function() {
          De || (De = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: t,
          configurable: !0
        });
      }
    }
    function tr(e, r) {
      {
        var t = function() {
          Ne || (Ne = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: t,
          configurable: !0
        });
      }
    }
    var ar = function(e, r, t, n, c, f, s) {
      var i = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: M,
        // Built-in properties that belong on the element
        type: e,
        key: r,
        ref: t,
        props: s,
        // Record the component responsible for creating this element.
        _owner: f
      };
      return i._store = {}, Object.defineProperty(i._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(i, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: n
      }), Object.defineProperty(i, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: c
      }), Object.freeze && (Object.freeze(i.props), Object.freeze(i)), i;
    };
    function nr(e, r, t, n, c) {
      {
        var f, s = {}, i = null, j = null;
        t !== void 0 && (Fe(t), i = "" + t), Qe(r) && (Fe(r.key), i = "" + r.key), Ze(r) && (j = r.ref, er(r, c));
        for (f in r)
          T.call(r, f) && !Ke.hasOwnProperty(f) && (s[f] = r[f]);
        if (e && e.defaultProps) {
          var m = e.defaultProps;
          for (f in m)
            s[f] === void 0 && (s[f] = m[f]);
        }
        if (i || j) {
          var p = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          i && rr(s, p), j && tr(s, p);
        }
        return ar(e, i, j, c, n, xe.current, s);
      }
    }
    var _e = O.ReactCurrentOwner, Le = O.ReactDebugCurrentFrame;
    function pe(e) {
      if (e) {
        var r = e._owner, t = L(e.type, e._source, r ? r.type : null);
        Le.setExtraStackFrame(t);
      } else
        Le.setExtraStackFrame(null);
    }
    var Pe;
    Pe = !1;
    function Ce(e) {
      return typeof e == "object" && e !== null && e.$$typeof === M;
    }
    function Me() {
      {
        if (_e.current) {
          var e = w(_e.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function or(e) {
      return "";
    }
    var Ae = {};
    function ir(e) {
      {
        var r = Me();
        if (!r) {
          var t = typeof e == "string" ? e : e.displayName || e.name;
          t && (r = `

Check the top-level render call using <` + t + ">.");
        }
        return r;
      }
    }
    function We(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var t = ir(r);
        if (Ae[t])
          return;
        Ae[t] = !0;
        var n = "";
        e && e._owner && e._owner !== _e.current && (n = " It was passed a child from " + w(e._owner.type) + "."), pe(e), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', t, n), pe(null);
      }
    }
    function Ye(e, r) {
      {
        if (typeof e != "object")
          return;
        if (Ee(e))
          for (var t = 0; t < e.length; t++) {
            var n = e[t];
            Ce(n) && We(n, r);
          }
        else if (Ce(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var c = se(e);
          if (typeof c == "function" && c !== e.entries)
            for (var f = c.call(e), s; !(s = f.next()).done; )
              Ce(s.value) && We(s.value, r);
        }
      }
    }
    function sr(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string")
          return;
        var t;
        if (typeof r == "function")
          t = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r.$$typeof === x))
          t = r.propTypes;
        else
          return;
        if (t) {
          var n = w(r);
          Re(t, e.props, "prop", n, e);
        } else if (r.PropTypes !== void 0 && !Pe) {
          Pe = !0;
          var c = w(r);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", c || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function lr(e) {
      {
        for (var r = Object.keys(e.props), t = 0; t < r.length; t++) {
          var n = r[t];
          if (n !== "children" && n !== "key") {
            pe(e), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", n), pe(null);
            break;
          }
        }
        e.ref !== null && (pe(e), g("Invalid attribute `ref` supplied to `React.Fragment`."), pe(null));
      }
    }
    var Ve = {};
    function $e(e, r, t, n, c, f) {
      {
        var s = fe(e);
        if (!s) {
          var i = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (i += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var j = or();
          j ? i += j : i += Me();
          var m;
          e === null ? m = "null" : Ee(e) ? m = "array" : e !== void 0 && e.$$typeof === M ? (m = "<" + (w(e.type) || "Unknown") + " />", i = " Did you accidentally export a JSX literal instead of a component?") : m = typeof e, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", m, i);
        }
        var p = nr(e, r, t, c, f);
        if (p == null)
          return p;
        if (s) {
          var I = r.children;
          if (I !== void 0)
            if (n)
              if (Ee(I)) {
                for (var ye = 0; ye < I.length; ye++)
                  Ye(I[ye], e);
                Object.freeze && Object.freeze(I);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ye(I, e);
        }
        if (T.call(r, "key")) {
          var ie = w(e), E = Object.keys(r).filter(function(vr) {
            return vr !== "key";
          }), Oe = E.length > 0 ? "{key: someKey, " + E.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ve[ie + Oe]) {
            var hr = E.length > 0 ? "{" + E.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Oe, ie, hr, ie), Ve[ie + Oe] = !0;
          }
        }
        return e === D ? lr(p) : sr(p), p;
      }
    }
    function cr(e, r, t) {
      return $e(e, r, t, !0);
    }
    function ur(e, r, t) {
      return $e(e, r, t, !1);
    }
    var fr = ur, dr = cr;
    je.Fragment = D, je.jsx = fr, je.jsxs = dr;
  }()), je;
}
process.env.NODE_ENV === "production" ? Te.exports = gr() : Te.exports = mr();
var a = Te.exports;
const pr = ({
  file: y,
  defaultBrightness: M = 100,
  defaultContrast: F = 100,
  defaultSaturate: D = 100,
  defaultGrayscale: z = 0,
  defaultFlipHorizontal: U = !1,
  defaultFlipVertical: A = !1,
  defaultZoom: k = 1,
  defaultRotate: d = 0
}) => {
  const _ = ze(null), b = ze(new Image()), [x, P] = C(""), [W, te] = C(M), [h, se] = C(F), [O, g] = C(D), [ae, le] = C(z), [J, ce] = C(d), [B, ue] = C(U), [Y, fe] = C(A), [V, H] = C(k), [w, R] = C(!1), [S, q] = C(null), [N, G] = C(0), [$, K] = C(0);
  Se(() => {
    if (y) {
      const o = URL.createObjectURL(y);
      return P(o), () => {
        URL.revokeObjectURL(o);
      };
    }
  }, [y]), Se(() => {
    Z();
  }, [y, x, J, B, Y, V, W, h, O, ae, N, $]);
  const Z = () => {
    if (!x) return;
    const o = _.current, u = o == null ? void 0 : o.getContext("2d"), v = b.current;
    b.current.src = x, b.current.onload = Z, v.onload = () => {
      if (o && u) {
        const L = v.width * V, T = v.height * V, re = (v.width - L) / 2, me = (v.height - T) / 2;
        if (o.width = v.width, o.height = v.height, u.clearRect(0, 0, o.width, o.height), u.filter = be(), u.save(), J) {
          const oe = o.width / 2, Re = o.height / 2;
          u.translate(oe, Re), u.rotate(J * Math.PI / 180), u.translate(-oe, -Re);
        }
        B && (u.translate(o.width, 0), u.scale(-1, 1)), Y && (u.translate(0, o.height), u.scale(1, -1)), u.translate(re + N, me + $), u.scale(V, V), u.drawImage(v, 0, 0, o.width, o.height), u.restore();
      }
    };
  }, Q = () => new Promise((o, u) => {
    const v = _.current;
    if (!v || !y) {
      o(null);
      return;
    }
    const L = (y.name.split(".").pop() || "").toLowerCase();
    let T;
    switch (L) {
      case "jpg":
      case "jpeg":
        T = "image/jpeg";
        break;
      case "png":
        T = "image/png";
        break;
      default:
        T = "image/png";
    }
    v.toBlob((re) => {
      if (re) {
        const me = new File([re], y.name, { type: re.type });
        o(me);
      } else
        o(null);
    }, T);
  }), de = () => {
    const o = _.current;
    if (o && y) {
      const u = document.createElement("a");
      u.download = y.name, u.href = o.toDataURL(y == null ? void 0 : y.type), u.click();
    }
  }, be = () => `brightness(${W}%) contrast(${h}%) grayscale(${ae}%) saturate(${O}%)`, he = () => {
    H((o) => o + 0.1);
  }, X = () => {
    H((o) => Math.max(o - 0.1, 0.1));
  };
  return {
    /** Reference to the canvas element. */
    canvasRef: _,
    /** Source URL of the image being edited. */
    imageSrc: x,
    /** Current brightness level. */
    brightness: W,
    /** Current contrast level. */
    contrast: h,
    /** Current saturation level. */
    saturate: O,
    /** Current grayscale level. */
    grayscale: ae,
    /** Current rotation angle in degrees. */
    rotate: J,
    /** Flag indicating if the image is flipped horizontally. */
    flipHorizontal: B,
    /** Flag indicating if the image is flipped vertically. */
    flipVertical: Y,
    /** Current zoom level. */
    zoom: V,
    /** Flag indicating if the image is being dragged. */
    isDragging: w,
    /** Starting coordinates for panning. */
    panStart: S,
    /** Current horizontal offset for panning. */
    offsetX: N,
    /** Current vertical offset for panning. */
    offsetY: $,
    /** Function to set the brightness level. */
    setBrightness: te,
    /** Function to set the contrast level. */
    setContrast: se,
    /** Function to set the saturation level. */
    setSaturate: g,
    /** Function to set the grayscale level. */
    setGrayscale: le,
    /** Function to set the rotation angle. */
    setRotate: ce,
    /** Function to set the horizontal flip state. */
    setFlipHorizontal: ue,
    /** Function to set the vertical flip state. */
    setFlipVertical: fe,
    /** Function to set the zoom level. */
    setZoom: H,
    /** Function to set the dragging state. */
    setIsDragging: R,
    /** Function to set the starting coordinates for panning. */
    setPanStart: q,
    /** Function to set the horizontal offset for panning. */
    setOffsetX: G,
    /** Function to set the vertical offset for panning. */
    setOffsetY: K,
    /** Function to zoom in. */
    handleZoomIn: he,
    /** Function to zoom out. */
    handleZoomOut: X,
    /** Function to handle pointer down events. */
    handlePointerDown: (o) => {
      R(!0);
      const u = o.clientX - (B ? -N : N), v = o.clientY - (Y ? -$ : $);
      q({ x: u, y: v });
    },
    /** Function to handle pointer up events. */
    handlePointerUp: () => {
      R(!1);
    },
    /** Function to handle pointer move events. */
    handlePointerMove: (o) => {
      if (w && S) {
        o.preventDefault();
        const u = o.clientX - S.x, v = o.clientY - S.y;
        G(B ? -u : u), K(Y ? -v : v);
      }
    },
    /** Function to handle wheel events for zooming. */
    handleWheel: (o) => {
      o.deltaY < 0 ? he() : X();
    },
    /** Function to download the edited image. */
    downloadImage: de,
    /** Function to generate the edited image file. */
    generateEditedFile: Q,
    /** Function to reset filters and styles to default. */
    resetFilters: () => {
      te(M), se(F), g(D), le(z), ce(d), ue(U), fe(A), H(k), G(0), K(0), q(null), R(!1);
    },
    /** Function to apply filters and transformations. */
    applyFilter: Z
  };
}, He = "text-gray-900 bg-white border border-gray-300 ml-2 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded-full text-sm px-2 py-1 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700", br = ({
  file: y,
  onSaveImage: M,
  allowColorEditing: F = !0,
  allowFlip: D = !0,
  allowRotate: z = !0,
  allowZoom: U = !0,
  downloadOnSave: A,
  open: k,
  onClose: d,
  modalHeight: _,
  modalWidth: b,
  canvasHeight: x,
  canvasWidth: P,
  maxCanvasHeight: W,
  maxCanvasWidth: te,
  labels: h = {
    close: "Close",
    save: "Save",
    rotate: "Rotate",
    brightness: "Brightness",
    contrast: "Contrast",
    saturate: "Saturate",
    grayscale: "Grayscale",
    reset: "Reset photo",
    flipHorizontal: "Flip photo horizontally",
    flipVertical: "Flip photo vertically",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out"
  }
}) => {
  if (!y)
    return null;
  const {
    canvasRef: se,
    brightness: O,
    setBrightness: g,
    contrast: ae,
    setContrast: le,
    saturate: J,
    setSaturate: ce,
    grayscale: B,
    setGrayscale: ue,
    rotate: Y,
    setRotate: fe,
    flipHorizontal: V,
    setFlipHorizontal: H,
    flipVertical: w,
    setFlipVertical: R,
    isDragging: S,
    handlePointerDown: q,
    handlePointerUp: N,
    handlePointerMove: G,
    handleWheel: $,
    handleZoomIn: K,
    handleZoomOut: Z,
    resetFilters: Q,
    downloadImage: de,
    generateEditedFile: be,
    applyFilter: he
  } = pr({ file: y });
  Se(() => {
    Q(), he();
  }, [k]);
  const X = (l, ee, o, u) => {
    var L;
    const v = parseInt((L = l.target) == null ? void 0 : L.value);
    !isNaN(v) && v >= o && v <= u && ee(v);
  }, ve = [
    {
      name: h.rotate,
      value: Y,
      setValue: fe,
      min: -180,
      max: 180,
      type: "range",
      id: "rotateInput",
      "aria-labelledby": "rotateInputLabel",
      hide: !z
    },
    {
      name: h.brightness,
      value: O,
      setValue: g,
      min: 0,
      max: 200,
      type: "range",
      id: "brightnessInput",
      "aria-labelledby": "brightnessInputLabel",
      hide: !F
    },
    {
      name: h.contrast,
      value: ae,
      setValue: le,
      min: 0,
      max: 200,
      type: "range",
      id: "contrastInput",
      "aria-labelledby": "contrastInputLabel",
      hide: !F
    },
    {
      name: h.saturate,
      value: J,
      setValue: ce,
      min: 0,
      max: 200,
      type: "range",
      id: "saturateInput",
      "aria-labelledby": "saturateInputLabel",
      hide: !F
    },
    {
      name: h.grayscale,
      value: B,
      setValue: ue,
      min: 0,
      max: 100,
      type: "range",
      id: "grayscaleInput",
      "aria-labelledby": "grayscaleInputLabel",
      hide: !F
    }
  ], ne = () => {
    Q(), d && d();
  }, ge = async () => {
    A && de();
    const l = await be();
    l && M(l), d && d();
  };
  return /* @__PURE__ */ a.jsx(a.Fragment, { children: k && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsx(
      "div",
      {
        "data-testid": "photo-editor-main",
        className: "photo-editor-main justify-center items-center flex overflow-auto fixed inset-0 z-50",
        children: /* @__PURE__ */ a.jsxs(
          "div",
          {
            style: {
              height: _ ?? "38rem",
              width: b ?? "40rem"
            },
            id: "photo-editor-modal",
            className: "relative rounded-lg shadow-lg max-sm:w-[22rem] bg-white dark:bg-[#1e1e1e]",
            children: [
              /* @__PURE__ */ a.jsxs("div", { className: "flex justify-end p-2 rounded-t", children: [
                /* @__PURE__ */ a.jsx(
                  "button",
                  {
                    className: He,
                    onClick: ne,
                    type: "button",
                    children: h.close
                  }
                ),
                /* @__PURE__ */ a.jsx(
                  "button",
                  {
                    className: He,
                    onClick: () => ge(),
                    type: "button",
                    "data-testid": "save-button",
                    children: h.save
                  }
                )
              ] }),
              /* @__PURE__ */ a.jsx("div", { className: "p-2", children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col", children: [
                /* @__PURE__ */ a.jsx(
                  "canvas",
                  {
                    style: {
                      width: P ?? "auto",
                      height: x ?? "auto",
                      maxHeight: W ?? "22rem",
                      maxWidth: te ?? "36rem"
                    },
                    className: `canvas border dark:border-gray-700 object-fit mx-auto ${S ? "cursor-grabbing" : "cursor-grab"}`,
                    "data-testid": "image-editor-canvas",
                    id: "canvas",
                    ref: se,
                    onPointerDown: q,
                    onPointerMove: G,
                    onPointerUp: N,
                    onPointerLeave: N,
                    onWheel: $,
                    width: typeof P == "number" ? P : void 0,
                    height: typeof x == "number" ? x : void 0
                  }
                ),
                /* @__PURE__ */ a.jsx("div", { className: "items-center flex m-1 flex-col", children: /* @__PURE__ */ a.jsx("div", { className: "flex flex-col bottom-12 gap-1 mt-4 max-sm:w-72 w-11/12 absolute ", children: ve.map(
                  (l) => !l.hide && /* @__PURE__ */ a.jsxs("div", { className: "flex flex-row items-center", children: [
                    /* @__PURE__ */ a.jsxs(
                      "label",
                      {
                        id: `${l.name}InputLabel`,
                        className: "text-xs font-medium text-gray-900 dark:text-white w-10",
                        children: [
                          l.name[0].toUpperCase() + l.name.slice(1),
                          ":",
                          " "
                        ]
                      }
                    ),
                    /* @__PURE__ */ a.jsx(
                      "input",
                      {
                        id: l.id,
                        "aria-labelledby": l["aria-labelledby"],
                        type: l.type,
                        value: l.value,
                        step: "1",
                        onChange: (ee) => X(ee, l.setValue, l.min, l.max),
                        min: l.min,
                        max: l.max,
                        className: "ml-[1.7rem] w-full h-1 bg-gray-200 rounded-lg appearance-none cursor-pointer range-sm dark:bg-gray-700"
                      }
                    ),
                    /* @__PURE__ */ a.jsx(
                      "input",
                      {
                        type: "number",
                        "aria-labelledby": l["aria-labelledby"],
                        value: l.value,
                        onChange: (ee) => X(ee, l.setValue, l.min, l.max),
                        min: l.min,
                        max: l.max,
                        className: "w-14 ml-2 rounded-md text-right bg-gray-100 text-black dark:bg-gray-700 dark:text-white"
                      }
                    )
                  ] }, l.name)
                ) }) }),
                /* @__PURE__ */ a.jsx("div", { className: "flex justify-center", children: /* @__PURE__ */ a.jsxs("div", { className: "mb-1 absolute bottom-0 mt-2", children: [
                  /* @__PURE__ */ a.jsx(
                    "button",
                    {
                      title: h.reset,
                      className: "mx-1 focus:ring-2 focus:ring-gray-300 dark:focus:ring-gray-700 rounded-md p-1",
                      onClick: Q,
                      "aria-label": h.reset,
                      type: "button",
                      children: /* @__PURE__ */ a.jsxs(
                        "svg",
                        {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          strokeWidth: "2",
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          className: "lucide lucide-rotate-ccw dark:stroke-slate-200",
                          children: [
                            /* @__PURE__ */ a.jsx("path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" }),
                            /* @__PURE__ */ a.jsx("path", { d: "M3 3v5h5" })
                          ]
                        }
                      )
                    }
                  ),
                  D && /* @__PURE__ */ a.jsxs("div", { className: "inline-block", "data-testid": "flip-btns", children: [
                    /* @__PURE__ */ a.jsx(
                      "button",
                      {
                        className: "mx-1 focus:ring-2 focus:ring-gray-300 dark:focus:ring-gray-700 rounded-md p-1",
                        onClick: () => H(!V),
                        type: "button",
                        title: h.flipHorizontal,
                        "aria-label": h.flipHorizontal,
                        children: /* @__PURE__ */ a.jsxs(
                          "svg",
                          {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            className: "lucide lucide-flip-horizontal dark:stroke-slate-200",
                            children: [
                              /* @__PURE__ */ a.jsx("path", { d: "M8 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h3" }),
                              /* @__PURE__ */ a.jsx("path", { d: "M16 3h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-3" }),
                              /* @__PURE__ */ a.jsx("path", { d: "M12 20v2" }),
                              /* @__PURE__ */ a.jsx("path", { d: "M12 14v2" }),
                              /* @__PURE__ */ a.jsx("path", { d: "M12 8v2" }),
                              /* @__PURE__ */ a.jsx("path", { d: "M12 2v2" })
                            ]
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ a.jsx(
                      "button",
                      {
                        className: "mx-1 focus:ring-2 focus:ring-gray-300 dark:focus:ring-gray-700 rounded-md p-1",
                        onClick: () => R(!w),
                        type: "button",
                        title: h.flipVertical,
                        "aria-label": h.flipVertical,
                        children: /* @__PURE__ */ a.jsxs(
                          "svg",
                          {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            className: "lucide lucide-flip-vertical dark:stroke-slate-200",
                            children: [
                              /* @__PURE__ */ a.jsx("path", { d: "M21 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v3" }),
                              /* @__PURE__ */ a.jsx("path", { d: "M21 16v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3" }),
                              /* @__PURE__ */ a.jsx("path", { d: "M4 12H2" }),
                              /* @__PURE__ */ a.jsx("path", { d: "M10 12H8" }),
                              /* @__PURE__ */ a.jsx("path", { d: "M16 12h-2" }),
                              /* @__PURE__ */ a.jsx("path", { d: "M22 12h-2" })
                            ]
                          }
                        )
                      }
                    )
                  ] }),
                  U && /* @__PURE__ */ a.jsxs("div", { className: "inline-block", "data-testid": "zoom-btns", children: [
                    /* @__PURE__ */ a.jsx(
                      "button",
                      {
                        "data-testid": "zoom-in",
                        type: "button",
                        className: "mx-1 focus:ring-2 focus:ring-gray-300 dark:focus:ring-gray-700 rounded-md p-1",
                        onClick: K,
                        title: h.zoomIn,
                        "aria-label": h.zoomIn,
                        children: /* @__PURE__ */ a.jsxs(
                          "svg",
                          {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            className: "lucide lucide-zoom-in dark:stroke-slate-200",
                            children: [
                              /* @__PURE__ */ a.jsx("circle", { cx: "11", cy: "11", r: "8" }),
                              /* @__PURE__ */ a.jsx("line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65" }),
                              /* @__PURE__ */ a.jsx("line", { x1: "11", x2: "11", y1: "8", y2: "14" }),
                              /* @__PURE__ */ a.jsx("line", { x1: "8", x2: "14", y1: "11", y2: "11" })
                            ]
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ a.jsx(
                      "button",
                      {
                        "data-testid": "zoom-out",
                        type: "button",
                        className: "mx-1 focus:ring-2 focus:ring-gray-300 dark:focus:ring-gray-700 rounded-md p-1",
                        onClick: Z,
                        title: h.zoomOut,
                        "aria-label": h.zoomOut,
                        children: /* @__PURE__ */ a.jsxs(
                          "svg",
                          {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            className: "lucide lucide-zoom-out dark:stroke-slate-200",
                            children: [
                              /* @__PURE__ */ a.jsx("circle", { cx: "11", cy: "11", r: "8" }),
                              /* @__PURE__ */ a.jsx("line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65" }),
                              /* @__PURE__ */ a.jsx("line", { x1: "8", x2: "14", y1: "11", y2: "11" })
                            ]
                          }
                        )
                      }
                    )
                  ] })
                ] }) })
              ] }) })
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ a.jsx("div", { className: "opacity-75 fixed inset-0 z-40 bg-black" })
  ] }) });
};
export {
  br as ReactPhotoEditor,
  pr as usePhotoEditor
};
